import { useSearchParams } from 'react-router-dom'
import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'

import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

import { clickCollectPOST } from 'featureSliced/shared/api/clickCollect/POST'
import { qrMenuPOST } from 'featureSliced/shared/api/qrMenu/POST'

import { SelectedProductsSlice } from 'featureSliced/shared/store/reducers/SelectedProductsReducer'
import { ReceiptModal } from 'components/ReceiptModal'

import { Card } from 'featureSliced/features/Profile/Card'
import { Payment } from 'featureSliced/features/Profile/Payment'

export type useCompleteDataTransType = () => void

export const useCompleteDataTransQRM = (): useCompleteDataTransType => {
  // Hooks
  const dispatch = useMyDispatch()
  const openModal = useOpenModal()
  const [searchParams, setSearchParams] = useSearchParams()

  // Store
  const isAppInit = useMySelector((state) => state.app.isAppInit)
  const clearBucket = QRMBucketSlice.actions.clearBucket
  const discardSelectedProducts =
    SelectedProductsSlice.actions.discardSelectedProducts

  // Variables
  const show_card = searchParams.get('show_card')
  const datatransTrxId = searchParams.get('datatransTrxId')
  const show_payment_variant = searchParams.get('show_payment_variant')

  // Functions
  const completeDataTransQRM = async () => {
    try {
      if (isAppInit && datatransTrxId) {
        const isDefaultPayment = !show_card && !show_payment_variant
        const isCCUpdate = !show_card && show_payment_variant
        const isLoyaltyRefill = show_card && !show_payment_variant
        if (isDefaultPayment) {
          openReceiptModal()
        }
        if (isCCUpdate) {
          completeCreditCardUpdate()
        }
        if (isLoyaltyRefill) {
          completeCardRefill()
        }
      }
    } catch (e) {
      searchParams.delete('show_card')
      searchParams.delete('datatransTrxId')
      searchParams.delete('show_payment_variant')
      setSearchParams(searchParams)
    }
  }

  const completeCreditCardUpdate = async () => {
    const success = await qrMenuPOST.completeNewPaymentVariant(
      datatransTrxId as string
    )
    if (success) {
      openModal({
        id: 'USER_CREDIT_CARD',
        title: '',
        components: [() => <Payment />],
      })
    }
    searchParams.delete('show_payment_variant')
    searchParams.delete('datatransTrxId')
    setSearchParams(searchParams)
  }

  const completeCardRefill = async () => {
    const success = await clickCollectPOST.refillCardComplete(datatransTrxId)
    if (success) {
      openModal({
        id: 'USER_CARD',
        title: '',
        components: [() => <Card />],
      })
    }
    searchParams.delete('show_card')
    searchParams.delete('datatransTrxId')
    setSearchParams(searchParams)
  }

  const openReceiptModal = async () => {
    openModal({
      id: 'RECEIPT_MODAL',
      // title: t('order.toMenu'),
      // onClose: handleReceiptModalClose,
      shouldHideCross: true,
      components: [
        ({ closeThisModal }) => (
          <ReceiptModal
            onCloseModal={(orderGuid?: string) => {
              closeThisModal()
              handleReceiptModalClose(orderGuid)
            }}
          />
        ),
      ],
    })
  }

  const handleReceiptModalClose = (orderGuid?: string) => {
    searchParams.delete('datatransTrxId')
    if (orderGuid) {
      searchParams.delete('table')
    }
    setSearchParams(searchParams)
    clearLocalStorage()
    dispatch(discardSelectedProducts()) // TODO: deprecated. remove
    dispatch(clearBucket())
  }

  const clearLocalStorage = () => {
    window.localStorage.removeItem('products_notes')
  }

  return completeDataTransQRM
}
